/**
 * ErrorMessage.tsx
 *
 * Consistent error message display component
 */

import React from 'react';

interface ErrorMessageProps {
  /** Error message text */
  message: string;

  /** Additional CSS classes */
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  className = '',
}) => {
  return (
    <p className={`text-xs text-red-500 mt-1 ${className}`}>
      {message}
    </p>
  );
};
